import { render } from "./showSingleFile.vue?vue&type=template&id=138b3298&scoped=true"
import script from "./showSingleFile.vue?vue&type=script&lang=js"
export * from "./showSingleFile.vue?vue&type=script&lang=js"

import "./showSingleFile.vue?vue&type=style&index=0&id=138b3298&scoped=true&lang=css"

import exportComponent from "C:\\Users\\EZZKAH\\IdeaProjects\\datapark\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-138b3298"]])

export default __exports__